// Delete job search alert  ***********************
// pathname: /v1/job-search-alert/{id}
// **********************************************************
import { GenericV1ErrorsArray, useSwrMutationApi } from '@hooks/useSwrApi';

interface UseSwrDeleteJobSearchAlertProps {
  locale?: Locale;
  id: number;
  successCallback?: () => void;
  errorCallback?: (errors: GenericV1ErrorsArray) => void;
}

/**
 * @description SWR mutation: Delete job search alert by id.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param id - number. The id of the job search alert to delete.
 * @param successCallback - function. The callback to execute after successful deletion.
 * @param errorCallback - function. The callback to execute on error.
 */
export const useSwrDeleteJobSearchAlert = (props: UseSwrDeleteJobSearchAlertProps) => {
  const {
    locale,
    id,
    successCallback,
    errorCallback,
  } = props;

  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, never>({
    url: `/v1/job-search-alert/${id}`,
    locale,
    fetcherConfig: {
      method: 'DELETE',
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
      onError: (errors) => {
        if (errorCallback) errorCallback(errors);
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};

